import { createContext, useContext, useEffect, useState } from 'react'
import useColumns from '../hooks/useColumns'

const VisualManagementDrawerContext = createContext()

const COLUMNS = {
  EMPLOYEES: 'employee',
  INTAKE: 'intakePending',
  HIGH_FATIGUE: 'highFatigue',
  NOTIFICATION: 'notification',
  COUNTER_MEASURE: 'counterMeasure',
  FATIGUE_LEVEL_8H: 'fatigueLevel8h',
}

export const VisualManagementDrawerProvider = ({ children }) => {
  const [columnsSelected, setColumnsSelected] = useState(null)
  const [loading, setLoading] = useState(true)
  const { getColumns } = useColumns()

  useEffect(() => {
    const fetchColumns = async () => {
      const { data } = await getColumns()

      setColumnsSelected({
        [COLUMNS.EMPLOYEES]: data.employees,
        [COLUMNS.HIGH_FATIGUE]: data.highFatigue,
        [COLUMNS.NOTIFICATION]: data.notification,
        [COLUMNS.COUNTER_MEASURE]: data.counterMeasure,
        [COLUMNS.FATIGUE_LEVEL_8H]: data.fatigueLevel8h,
        [COLUMNS.INTAKE]: data.intakePending,
      })
      setLoading(false)
    }

    setLoading(true)
    fetchColumns()
  }, [])

  return (
    <VisualManagementDrawerContext.Provider
      value={{
        COLUMNS,
        columnsSelected,
        setColumnsSelected,
        loading,
      }}
    >
      {children}
    </VisualManagementDrawerContext.Provider>
  )
}

export const useVisualManagementDrawer = () => {
  return useContext(VisualManagementDrawerContext)
}
